import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import { debounceTime, Subject, Subscription } from "rxjs";
import { EventManagerService } from "src/app/common/service/event-manager.service";
import { Constant } from "src/app/common/constant";
import { DialogService } from "src/app/common/service/dialog.service";
import { ManageComponent } from "src/app/common/extend-code/manage.component";
import { BusinessOperationsService } from "../../business-operations.service";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: "search-agency",
  styleUrls: ["./search-agency.component.scss"],
  templateUrl: "./search-agency.component.html",
  encapsulation: ViewEncapsulation.None
})
export class SearchAgencyComponent extends ManageComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @Input() agencyOrganizationId: any;
  @Input() isEmitFullAgency: boolean = false;
  @Output() result: EventEmitter<any> = new EventEmitter(); 
  public Constant = Constant;
  agencyPartners: any[] = [];
  callSearchAgency$ = new Subject();
  remainingAgency: any;
  constructor(
    public eventManager: EventManagerService,
    public dialogService: DialogService,
    private businessOperationsService: BusinessOperationsService,
    ) {

    super(eventManager, dialogService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.subscriptions.push(
      this.callSearchAgency$.pipe(
        debounceTime(500),
        ).subscribe((event)=> { return this.loadAgencyPartner(event);})
    )
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.agencyOrganizationId && changes.agencyOrganizationId.currentValue) {
      this.searchAgency(undefined);
    }
  }
  ngAfterViewInit(): void {
    this.callSearchAgency$.next('');
  }
  changeAgencyPartner(agencyPartner) {
    if (!agencyPartner) {
      this.result.emit(undefined);
      return;
    }
    agencyPartner = agencyPartner + '';
    const split = agencyPartner.split('-');
    const agencyCode = (split.pop() || '').trim();
    const findAgency = this.agencyPartners.find(item => agencyCode === item.agencyPartnerCode) || {};
    if (!findAgency) {
      return;
    }
    this.searchParams.agencyPartnerId = findAgency.id;
    if (!this.isEmitFullAgency) {
      this.result.emit(findAgency.id);
    } else {
      this.result.emit(findAgency);
    }
  }
  searchAgency(text) {
    this.callSearchAgency$.next(text);
  }
  loadAgencyPartner(text) {
    const body = {
      searchField: text,
      page: 1,
      size: 10,
      statusCodes: ['PARTNER_INIT', 'PARTNER_PENDING', 'PARTNER_REJECT', 'PARTNER_CONSULTANT'],
      agencyOrganizationId: this.agencyOrganizationId,
      isNoAum : true
    }
    this.businessOperationsService
    .queryAgency(body)
    .subscribe(
      (res: any) => {
        if (!res) {
          return;
        }
        this.agencyPartners = (res.data.list || []).map((item) => {
          item.showName = `${item.name} - ${item.agencyPartnerCode}`;
          return item;
        });
        const totalItems = res.data.total;
        this.remainingAgency = totalItems - 20 > 0 ? totalItems - 20 : 0;
      });
  }
}
